import Select, { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import React from "react";
import { list } from "sources/books/transportColumns";

const TransportColumnFilter = (props) => {
    const selectProps = {
        ...defaultMultipleSelectProps,
        components: { ValueContainer },
        placeholder: "Колонна",
        url: list,
        propName: "name",
        onChange: props.setFilter,
        value: props.values.transportColumnId
            ? Array.isArray(props.values.transportColumnId)
                ? props.values.transportColumnId
                : props.values.transportColumnId
            : undefined,
        inputProps: { name: "transportColumnId" },
        className: "report__filters--control",
        styles: {
            control: (styles) => ({ ...styles, minHeight: "31px", fontSize: "14px" }),
            indicatorsContainer: (styles) => ({ ...styles, height: "29px" }),
        },
        ...props.selectProps,
    };
    return (
        <div className="mb-md-0 report__filters--mr">
            <Select {...selectProps} />
        </div>
    );
};

export default TransportColumnFilter;
